import { BaseDto } from "src/dtos/common/baseDto";

export interface WmsTransportDto {
	wmsTransportHeaderDto: WmsTransportHeaderDto;
	wmsTransportDetailDtoList: WmsTransportDetailDto[];
	wmsTransportLotDtoList?: WmsTransportLotDto[];
}


export interface WmsTransportHeaderDto extends BaseDto {

	transportNo: string;
	compCd: string;
	compNm: string;
	logicCenter: string;
	warehouseCd: string;
	warehouseNm: string;
	transportDt: string | undefined;
	inoutType: string;
	inoutClass: string;
	customCd: string;
	customNm: string;
	otherLogicCenter: string;
	inoutMethod: string;
	empNo: string;
	empNm: string;
	transAmt: number;
	vatAmt: number;
	totalAmt: number;
	telNo: string;
	faxNo: string;
	email: string;
	post: string;
	address: string;
	otherAddress: string;
	trackingNo: string;
	approveFlg: string;
	remark: string;

	inserted: boolean;			// 생성여부
	isModified: boolean;		// 수정여부
}

export interface WmsTransportDetailDto extends BaseDto {

	transportNo: string;
	itemNo: string;
	compCd: string;
	compNm: string;
	logicCenter: string;
	transportDt: string | undefined;
	inoutType: string;
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	itemStatus: string;
	unit: string;
	qty: number;
	cost: number;
	amt: number;
	basOrderType: string;
	basOrderNo: string;
	basOrderItemNo: string;
	remark: string;
	inspectionResult?: string;

	inserted: boolean;			// 생성여부
	isModified: boolean;		// 수정여부
}

export const defaultWmsTransportHeaderDto: WmsTransportHeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: undefined,
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',
	inserted: false,
	isModified: false,
};

export const defaultWmsTransportDetailDto: WmsTransportDetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: undefined,
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',
	inspectionResult: '',
	inserted: false,
	isModified: false,
};

/**
 * 수불 LOT 정보 DTO (wms_transport_lot)
 */
export interface WmsTransportLotDto extends BaseDto {
	transportNo: string;
	itemNo: string;
	itemCd: string;
	lotNo: string;
	itemStatus: string;
	purchaseLotNo: string;
	lotQty: number;
	unit: string;
	remark: string;

	inserted: boolean;			// 생성여부
	isModified: boolean;		// 수정여부
}

